export default "__VITE_ASSET__CAwDMU4Y__"